// db/livekit.ts
import { registerQuery } from "@adornis/baseql/metadata/register.js";
import { getLivekitRoomTokenResolver } from "../server/resolver/livekit.js";
var getLivekitRoomToken = registerQuery({
  operationName: "getLivekitRoomToken",
  resolve: getLivekitRoomTokenResolver,
  type: () => String,
  params: [
    { name: "roomID", type: () => String },
    { name: "name", type: () => String }
  ]
});
export {
  getLivekitRoomToken
};
